package com.anjuros.website.templates.template6.modules


import com.anjuros.website.templates.template6.util.ResKey
import com.varabyte.kobweb.compose.ui.graphics.Colors
import org.jetbrains.compose.web.css.CSSColorValue

enum class Template6Section(
    val id: String,
    val title: ResKey,
    val color: CSSColorValue,
    val path: String
) {

    Home(
        id = "home",
        title = ResKey.TEMPLATE6_SECTION1,
        color = Template6Theme.Secondary.rgb,
        path = "#home"
    ),
    Services(
        id = "services",
        title = ResKey.TEMPLATE6_SECTION2,
        color = Template6Theme.Secondary.rgb,
        path = "#services"
    ),
    WhyChoose(
        id = "whychoose",
        title = ResKey.TEMPLATE6_SECTION3,
        color = Template6Theme.Secondary.rgb,
        path = "#whychoose"
    ),
    Testimonial(
        id = "reviews",
        title = ResKey.TEMPLATE6_SECTION6,
        color = Colors.White,
        path = "#reviews"
    ),

    FAQ(
        id = "faq",
        title = ResKey.TEMPLATE6_SECTION5,
        color = Template6Theme.Secondary.rgb,
        path = "#faq"
    ),
    Contact(
        id = "contact",
        title = ResKey.TEMPLATE6_SECTION4,
        color = Template6Theme.Secondary.rgb,
        path = "#contact"
    )
}